const websiteConfigCollection = require('od-modules/collections/website.collection').getInstance();
const ShoppingCart = require('od-modules/cart/cart');
const trackingUtils = require('od-modules/utils/tracking.utils');
const detailsTotalPriceCalculator = require('od-modules/helpers/price/details.total.price.calculator');
const membershipService = import('od-modules/secure_store/services/MembershipService');

const SOURCE = {
    action: ShoppingCart.sources.actions.USER_REQUESTED,
    target: ShoppingCart.sources.targets.FARE_RULES,
};

const CLASSIC_DATA = {
    id: 'CLASSIC',
    type: 'CLASSIC',
    concept: '',
    price: {
        total: 0,
    },
    committable: false,
    extra: {
        trackingLabel: 'CLASSIC',
    },
};
const FARE_RULES_PAGE_TRACKING = 'farerules';
const pagePrefix = Odigeo.SessionScope.flowProduct === 'dp' ? 'dp' : 'fl';
const PAGES = {
    details: 'pax',
    passengersinfo: 'pax',
    payment: 'pay',
    ancillaries: 'anc',
    canx: 'canx',
    insurance: 'ins',
    insurances: 'cov',
    selection: 'sel',
    flex: 'flex',
    servicepack: 'so',
    additions: 'ex',
    prime: 'prime',
    none: 'none',
    farerules: 'farerules',
};

const getTrackingLabel = (product) => product.extra && product.extra.trackingLabel ? product.extra.trackingLabel : product.type;

const filterPrev = (productsToRemove) => (product) => product.committable && productsToRemove.includes(product.type);

const isMeta = () => Odigeo.SessionScope.isMeta ? 1 : 0;

const sendSelectionTracking = ({add = [], remove = []} = {}) => {
    if (!add[0]) {
        return;
    }

    const policy = getTrackingLabel(add[0]);
    const prevProducts = ShoppingCart.getItems()
        .filter(filterPrev(remove))
        .map(getTrackingLabel).toString() || 'none';

    const label = `ancillary_product_select_cat:FARERULES_meta:${isMeta()}_pol:${policy}_pag:paxfl_prev:${prevProducts}`;
    trackingUtils.trackEvent('ancillary_selection', label);
};

const removePreviouslyAdded = ({add = []} = {}) => {
    const isAdded = (product) => add.some((added = {}) => added.id === product.id);

    ShoppingCart.take.fareRules((i) => !isAdded(i))
        .forEach((item) => ShoppingCart.removeProduct(item.name));
};

const removeIncompatible = ({remove = []} = {}) => {
    if (websiteConfigCollection.getAB().fareRulesProductHiding) {
        ShoppingCart.getItems(({type}) => remove.includes(type))
            .map(({name}) => ShoppingCart.removeProduct(name, {source: SOURCE}));
    }
};

const addSelectedToCart = ({add = []} = {}) => {
    add.map((product = {}) => ShoppingCart.builders
        .fareRule.id(product.type, product.id).data(product)
        .from(ShoppingCart.sources.actions.USER_REQUESTED, ShoppingCart.sources.targets.FARE_RULES)
        .add());
};

const getPriceFromCalculator = () => {
    const {totalWithoutAncillariesPerPassenger} = detailsTotalPriceCalculator.getTotal() || {};
    return totalWithoutAncillariesPerPassenger;
};

const trackSelection = (policy, page) => trackingUtils.trackEvent(
    'ancillary_selection', `ancillary_product_selected_cat:FARERULES_meta:${isMeta()}_pol:${policy}_pag:${page}`
);

const getFirst = ([first] = []) => first;

const getTickets = () => getFirst(ShoppingCart.getItems(({name} = {}) => name === 'TICKETS')) || {};

const getPrice = ({price = {}} = {}) => price;

const getTicketPriceFromCart = () => {
    const {total} = getPrice(getTickets());
    return parseFloat(Odigeo.Session.get('newPricePerPax')) || total;
};

const trackFareRulesContinueMobile = (page = 'none') => {
    const pageName = PAGES[page];
    const fareRule = ShoppingCart.take.fareRules();

    if (Odigeo.Utils.isMobile()) {
        if (!fareRule.length && (!Odigeo.SessionScope.isMeta || Odigeo.AB.isFarePlusReenableMobileMetaActive)) {
            trackSelection('NONE', `${pageName}${pagePrefix}`);
        } else {
            fareRule.forEach(({extra} = {}) =>
                trackSelection(extra.trackingLabel, `${pageName}${pagePrefix}`)
            );
        }
    }
};

const trackFareRulesContinueDesktop = (page = 'none') => {
    const fareRule = ShoppingCart.take.fareRules();
    const item = fareRule.length > 0 ? fareRule[0].extra.trackingLabel : 'none';

    if (Odigeo.Utils.isDesktop()) {
        trackSelection(item, `${page}${pagePrefix}`);
    }
};

const areFareRulesLoaded = () => {
    const {fareRules: {loaded = false} = {}} = ShoppingCart.tracking || {};
    return loaded;
};

const shouldConnectToPricingStore = () =>
    (Odigeo.Utils.isMobile() && !Odigeo.SessionScope.isMeta) || (Odigeo.Utils.isDesktop() && Odigeo.AB.sidebarRevamp);

const shouldConnectToMembershipDetailsStore = () => (Odigeo.Utils.isDesktop() && Odigeo.AB.sidebarRevamp);

const shouldConnectToInsuranceShoppingItems = () => (Odigeo.Utils.isDesktop() && Odigeo.AB.isPriceMatchFareRules);

const shouldConnectToStore = () => shouldConnectToPricingStore() || shouldConnectToMembershipDetailsStore();

const getSelectorsToConnect = () => {
    const selectors = [];
    if (shouldConnectToPricingStore()) {
        selectors.push('pricing');
    }
    if (shouldConnectToMembershipDetailsStore()) {
        selectors.push('membershipSubscriptionDetails');
    }
    if (shouldConnectToInsuranceShoppingItems()) {
        selectors.push('insuranceShoppingItems');
    }
    return selectors;
};

module.exports = Backbone.Model.extend({
    connect: shouldConnectToStore(),
    selectors: getSelectorsToConnect(),
    fareRulesEnabled: false,
    defaults: {
        membershipSubscriptionDetailsDTO: null,
    },
    initialize() {
        if (!Odigeo.SessionScope.isMeta) {
            if (Odigeo.Utils.isMobile()) {
                membershipService.then(({default: service}) => {
                    service.getMembershipSubscriptionDetails()
                        .then(this.updateMembershipSubscriptionDetailsDTO.bind(this))
                        .catch(() => this.set('membershipSubscriptionDetailsDTO', {}));
                });
            }
            if ((Odigeo.AB.isFarePlusPricingDisplayMobileActive) && ShoppingCart.take.fareRules().length === 0) {
                this.addClassicFareRule();
            }
        }
    },
    updateMembershipSubscriptionDetailsDTO(data) {
        this.set('membershipSubscriptionDetailsDTO', data);
    },
    areFareRulesPreventingContinuance() {
        return this.get('fareRulesEnabled')
        && ShoppingCart.take.fareRules().length === 0;
    },
    isFareRulesNonMetas() {
        return !Odigeo.SessionScope.isMeta
            || (websiteConfigCollection.getAB().farePlusNoMetaDesktop && !Odigeo.SessionScope.isMeta);
    },
    isFareRulesRemoveForceSelectionEnabled() {
        return (websiteConfigCollection.getAB().fareRulesRemoveForceSelection && Odigeo.SessionScope.isMeta)
            || this.isFareRulesNonMetas() || (Odigeo.Utils.isDesktop() && !Odigeo.SessionScope.isMeta);
    },
    addClassicFareRule() {
        ShoppingCart.builders
            .fareRule.id(CLASSIC_DATA.type, CLASSIC_DATA.id)
            .from(ShoppingCart.sources.actions.AUTOMATICALLY_ADDED, ShoppingCart.sources.targets.FARE_RULES)
            .data(CLASSIC_DATA)
            .add();
    },
    onFareRuleSelect(data = {}) {
        sendSelectionTracking(data);
        removePreviouslyAdded(data);
        addSelectedToCart(data);
        removeIncompatible(data);
        if (Odigeo.Utils.isMobile() && !(!Odigeo.SessionScope.isMeta || Odigeo.AB.isFarePlusReenableMobileMetaActive)) {
            this.trackFareRulesContinue({page: FARE_RULES_PAGE_TRACKING});
        }
    },
    onFareRuleSelectOF2(data = {}) {
        removePreviouslyAdded(data);
        addSelectedToCart(data);
    },
    isPrimeAdded() {
        const membershipSubscriptionDetails = this.get(
            Odigeo.Utils.isMobile() && !Odigeo.SessionScope.isMeta ? 'membershipSubscriptionDetailsDTO' : 'membershipSubscriptionDetails');
        return membershipSubscriptionDetails &&
            membershipSubscriptionDetails.primePriceSelectedInResults;
    },
    shouldIncludePrimeInPrice() {
        return this.isFareRulesNonMetas();
    },
    getPriceFromStore() {
        const pricingObject = this.get('pricing') || {};

        if (this.shouldIncludePrimeInPrice()) {
            const itineraryPrice = this.isPrimeAdded()
                ? pricingObject.itineraryPricePerPaxPrimeFareSelected
                : pricingObject.itineraryPricePerPaxFullFareSelected;
            const vinInsurancePrice = this.calculateVinInsurancePrice();
            return itineraryPrice + vinInsurancePrice;
        }

        return pricingObject.itineraryPricePerPaxWithPerks;
    },
    calculateVinInsurancePrice() {
        const insuranceShoppingItems = this.get('insuranceShoppingItems') || [];
        const vinInsurance = insuranceShoppingItems.find(({insurance}) => {
            return insurance.policy === 'NEWHUB162' || insurance.policy === 'HUB_AX05';
        }) || {};
        return vinInsurance.totalPrice || 0;
    },
    calculateLegacyPrice() {
        return shouldConnectToStore() ? this.getPriceFromStore() : getPriceFromCalculator();
    },
    getPrice() {
        return Odigeo.Utils.isMobile() && Odigeo.SessionScope.isMeta ? getTicketPriceFromCart() : this.calculateLegacyPrice();
    },
    hasErrors() {
        return this.areFareRulesPreventingContinuance() && !this.isFareRulesRemoveForceSelectionEnabled();
    },
    mustAddClassic() {
        return this.areFareRulesPreventingContinuance() && this.isFareRulesRemoveForceSelectionEnabled();
    },
    trackFareRulesContinue({page = 'none'} = {}) {
        if (areFareRulesLoaded()) {
            trackFareRulesContinueMobile(page);
            trackFareRulesContinueDesktop(page);
        }
    },
});
